import { RequestDataPutTaxInvoicer } from '@/form/form-dto/hub-adjustment/RequestDataPutTaxInvoicer';
import { taxInvoiceService } from '@/services';
import { mutationType } from '@/vuex-store/hub-adjustment/tax-invoice-dialog/mutations';
const actionType = {
    // 다이얼로그 정보 입력
    setDialogDetail: 'setDialogDetail',
    // 다이얼로그 수정모드 변경
    setIsEditMode: 'setIsEditMode',
    // 세금계산서 조회
    getTaxInvoiceById: 'getTaxInvoiceById',
    // 수정 폼 업데이트
    updateFormData: 'updateFormData',
    // 세금계산서 수정
    putTaxInvoiceById: 'putTaxInvoiceById',
    // 세금계산서 발행
    postTaxInvoice: 'postTaxInvoice',
    // 전체 초기화
    resetStore: 'resetStore',
};
const actions = {
    [actionType.setDialogDetail]({ commit }, payload) {
        commit(mutationType.SET_DIALOG_DETAIL, payload);
    },
    [actionType.setIsEditMode]({ commit }, isEditMode = true) {
        commit(mutationType.INIT_FORM_DATA);
        commit(mutationType.SET_IS_EDIT_MODE, isEditMode);
    },
    // 세금계산서 조회
    async [actionType.getTaxInvoiceById]({ commit, state }) {
        const { hubId, id: taxInvoiceId, } = state.dialogDetail;
        if (!hubId || !taxInvoiceId) {
            return;
        }
        try {
            const response = await taxInvoiceService.getTaxInvoiceById(hubId, taxInvoiceId);
            commit(mutationType.GET_TAX_INVOICE_BY_ID, response.data);
            commit(mutationType.INIT_FORM_DATA);
        }
        catch (error) {
            console.log('getTaxInvoiceById', error);
        }
    },
    [actionType.updateFormData]({ commit }, { key, value }) {
        commit(mutationType.UPDATE_FORM_DATA, {
            key,
            value,
        });
    },
    // 세금계산서 수정
    async [actionType.putTaxInvoiceById]({ commit, state }) {
        const { hubId, id: taxInvoiceId, } = state.dialogDetail;
        const { invoicerFormData } = state;
        if (!hubId || !taxInvoiceId) {
            return;
        }
        const RequestData = new RequestDataPutTaxInvoicer(invoicerFormData).makeData();
        const response = await taxInvoiceService.putTaxInvoiceById(hubId, taxInvoiceId, RequestData);
        commit(mutationType.PUT_TAX_INVOICE_BY_ID, response.data);
        commit(mutationType.INIT_FORM_DATA);
    },
    // 세금계산서 발행
    async [actionType.postTaxInvoice]({ state }) {
        const { hubId, id: taxInvoiceId, } = state.dialogDetail;
        if (!hubId || !taxInvoiceId) {
            return;
        }
        await taxInvoiceService.postTaxInvoiceToPublish(hubId, taxInvoiceId);
    },
    // 일괄 리셋
    [actionType.resetStore]({ commit }) {
        commit(mutationType.RESET_STORE);
    },
};
export default actions;
